import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';
import EmptyState from './EmptyState';
import Button from './Button';
import { ListPageSkeleton } from './PageSkeleton';

function ViewState({
  loading = false,
  error = null,
  empty = false,
  onRetry,
  skeleton = 'list',
  skeletonRows = 5,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyAction,
  children,
  className = '',
}) {
  const { t } = useLanguage();
  const copy = t.ux?.viewState || {};

  if (loading) {
    if (skeleton === 'none') {
      return (
        <div className={`flex items-center justify-center py-12 text-sm text-secondary-500 ${className}`}>
          {t.common.loading}
        </div>
      );
    }
    return <ListPageSkeleton rows={skeletonRows} className={className} />;
  }

  if (error) {
    return (
      <div
        className={`card-premium flex flex-col items-center gap-3 border border-error-200/80 bg-error-50/60 p-6 text-center   ${className}`}
        role="alert"
      >
        <ExclamationTriangleIcon className="h-8 w-8 text-error-500" aria-hidden="true" />
        <div>
          <p className="font-semibold text-error-900 ">
            {copy.loadFailed || 'Could not load this section'}
          </p>
          {typeof error === 'string' ? (
            <p className="mt-1 text-sm text-error-700 ">{error}</p>
          ) : null}
        </div>
        {onRetry ? (
          <Button
            type="button"
            variant="outline"
            size="compact"
            onClick={() => {
              void onRetry();
            }}
          >
            {copy.retry || 'Try again'}
          </Button>
        ) : null}
      </div>
    );
  }

  if (empty) {
    return (
      <EmptyState
        icon={emptyIcon}
        title={emptyTitle}
        description={emptyDescription}
        action={emptyAction}
        className={className}
      />
    );
  }

  return children;
}

export default ViewState;
